var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMapMarkerNeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "-114.642 -416.478 1071.173 1428.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.903,982.938c-405.312-587.582-480.544-647.885-480.544-863.83c0-295.797,239.79-535.587,535.587-535.587 c295.794,0,535.586,239.79,535.586,535.587c0,215.945-75.235,276.248-480.545,863.83 C449.389,1021.359,392.496,1021.356,365.903,982.938z M420.946,342.27c123.247,0,223.159-99.912,223.159-223.161 c0-123.25-99.912-223.161-223.159-223.161c-123.251,0-223.164,99.911-223.164,223.161 C197.782,242.358,297.694,342.27,420.946,342.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapMarkerNeat);
export default __webpack_public_path__ + "static/media/icon-map-marker-neat.fcfaf6cfe2e6790918170a58ce66d0d3.svg";
export { ForwardRef as ReactComponent };